<div
  class="flex flex-col items-center gap-4 group-[.custom-theme]/body:bg-[image:--theme-gradient] bg-[image:--color-background-newsletter]"
>
  <div class="w-full bg-[--color-border-primary] h-[1px] mt-2"></div>

  <div class="flex flex-col md:flex-row gap-3 md:gap-6 items-center pb-4">
    <h4 class="text-[--color-text-footer-titles]">{{ ['placeholderNewsLetter'] | translate }}</h4>
    <form [formGroup]="newsletterForm" (ngSubmit)="submit()">
      <div
        [ngClass]="{
          '!border-red-600': formSubmitAttempt() && newsletterForm.invalid,
          '!rounded-e-3xl': !brand.isLebara(),
        }"
        class="flex items-center bg-white h-14 border border-solid border-color-gray-3 rounded-md w-full px-2 mb-3 sm:mb-0 lg:mb-0"
      >
        <lib-svg class="mr-2 text-gray-2 normal-plus" svg="analog-mail" />
        <input
          class="focus-within:outline-none text-dark flex-grow pl-2.5 read-only:text-[--neutral-500]"
          type="email"
          id="email"
          name="email"
          [placeholder]="['emailAddressPlaceholder'] | translate"
          [readonly]="loading()"
          formControlName="email"
        />
        <lib-button
          [text]="['newsletterSignUpButton'] | translate"
          [loading]="loading()"
          [disabled]="loading()"
          type="mat-filled-button"
        />
      </div>

      @if (
        formSubmitAttempt() &&
        newsletterForm.invalid &&
        newsletterForm.hasError('email', 'email') &&
        newsletterForm.controls['email'] !== null
      ) {
        <div class="text-xs font-bold text-white" [ngClass]="{ 'text-dark': brand.isChmobile }">
          {{ ['validEmailRequired'] | translate }}
        </div>
      }
    </form>
  </div>
</div>
